var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3912 60.2283C30.3912 60.2283 27.5932 61.8728 32.3824 62.4292C38.1844 63.0982 41.1498 63.0023 47.5436 61.7792C47.5436 61.7792 49.2246 62.8445 51.5722 63.7672C37.2389 69.9758 19.1332 63.4076 30.3912 60.2283Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6399 52.1265C28.6399 52.1265 25.5017 54.4742 30.2945 54.9753C36.4923 55.6215 41.3869 55.6744 49.8565 54.0261C49.8565 54.0261 51.0279 55.2264 52.8699 55.8828C35.5401 61.0044 16.2378 56.2867 28.6399 52.1265Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4054 38.3832C46.9371 42.4927 42.4774 46.1908 42.4774 46.1908C42.4774 46.1908 51.4451 41.512 47.3266 35.6531C43.4801 30.1892 40.5304 27.4744 56.4991 18.1143C56.4991 18.1143 31.4335 24.4413 43.4054 38.3832Z",
    fill: "#EE2B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3621 66.2209C62.3621 66.2209 64.4327 67.9451 60.0818 69.2791C51.8084 71.8121 25.6471 72.5771 18.3796 69.38C15.7671 68.2314 20.6663 66.6373 22.2074 66.3028C23.8146 65.9506 24.733 66.0162 24.733 66.0162C21.8277 63.9477 5.95408 70.0779 16.67 71.8335C45.8939 76.6234 69.9424 69.6766 62.3621 66.2209Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7367 43.7323C31.7367 43.7323 18.4294 46.9267 27.0242 48.0867C30.6532 48.5778 37.8876 48.4667 44.6262 47.8961C50.1333 47.4265 55.6632 46.4283 55.6632 46.4283C55.6632 46.4283 53.7213 47.2688 52.3164 48.2383C38.8031 51.8303 12.6978 50.1593 20.2132 46.4851C26.5689 43.38 31.7367 43.7323 31.7367 43.7323Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6086 57.2179C69.3455 50.0034 62.9941 43.0704 58.5609 44.0045C57.4743 44.233 56.9898 44.4311 56.9898 44.4311C56.9898 44.4311 57.3932 43.7924 58.1637 43.516C66.9339 40.3997 73.6789 52.707 55.3325 57.5815C55.3325 57.5817 55.5451 57.3896 55.6086 57.2179Z",
    fill: "#5382A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3263 3C47.3263 3 54.934 10.6915 40.1107 22.519C28.224 32.0066 37.4002 37.4162 40.1058 43.5969C33.1673 37.2698 28.0754 31.7 31.4914 26.5162C36.5054 18.9069 50.3959 15.2176 47.3263 3Z",
    fill: "#EE2B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0868 76.7673C46.2725 77.6204 66.5207 76.294 67.0002 69.9883C67.0002 69.9883 66.0784 72.3787 56.1029 74.2771C44.8486 76.4177 30.9681 76.1678 22.7354 74.7959C22.7355 74.7957 24.4207 76.2057 33.0868 76.7673Z",
    fill: "#5382A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/Java.ed9cb60ba86ed931cf02af24ac5afa05.svg";
export { ForwardRef as ReactComponent };